import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Box from 'reusecore/src/elements/Box';
import Text from 'reusecore/src/elements/Text';
import Heading from 'reusecore/src/elements/Heading';
import Image from 'reusecore/src/elements/Image';
import Container from '../../components/UI/Container';
import Breadcrumbs from '../Breadcrumbs';
import Searchbar from '../Searchbar';
import MedlightProducts from './MedlightProducts';

import SideBar from './sidebar';

import {
  ProductListSectionWrapper,
  ProductItem,
  ProductImageWrapper
} from './products-section.style';

const ProductList = ({
  paths,
  title,
  // description,
  secTitleWrapper,
  secTitle,
  // secDescription,
  productLogoStyle,
  productNameStyle,
  productDetailsStyle,
  portfolioImage,
  portfolioDetails,
  products,
  allProducts,
  topRow,
  topCol
}) => {
  return (
    <ProductListSectionWrapper>
      <Container noGutter mobileGutter>
        <MedlightProducts
          heading='Productos MedLight'
          // subtitle='Algunos productos relacionados con esta noticia:'
          // featured={featured}
        />
        <Box flexBox justifyContent='space-between' {...topRow}>
          <Box {...topCol}>
            <Breadcrumbs paths={paths} />
          </Box>
          <Box {...topCol}>
            <Searchbar searchable={allProducts} width='100%' />
          </Box>
        </Box>
        <Box {...secTitleWrapper}>
          <Heading {...secTitle} content={title} />
        </Box>
        <Box className='row'>
          <Box className='col' {...portfolioImage}>
            <SideBar active={paths.reverse()[0].title} />
          </Box>
          <Box className='col' {...portfolioDetails}>
            <Box className='row product_list'>
              {products.length > 0 &&
                products.map(prod => {
                  const { frontmatter } = prod.node;
                  return (
                    <Box
                      className='col'
                      key={`product-item-${frontmatter.slug}`}
                    >
                      <ProductItem>
                        <ProductImageWrapper>
                          <Image
                            src={frontmatter.thumbnail}
                            alt={`light-up-${frontmatter.title}`}
                            {...productLogoStyle}
                          />
                        </ProductImageWrapper>
                        <Link to={`/producto/${frontmatter.slug}`}>
                          <Heading
                            content={frontmatter.title}
                            {...productNameStyle}
                          />
                        </Link>
                        <Text
                          content={frontmatter.description}
                          {...productDetailsStyle}
                        />
                      </ProductItem>
                    </Box>
                  );
                })}
            </Box>
            {!products.length && (
              <Box className='row no_items'>Sin productos para mostrar</Box>
            )}
          </Box>
        </Box>
      </Container>
    </ProductListSectionWrapper>
  );
};

ProductList.propTypes = {
  topRow: PropTypes.object,
  topCol: PropTypes.object,
  secTitleWrapper: PropTypes.object,
  secTitle: PropTypes.object,
  secDescription: PropTypes.object,
  productLogoStyle: PropTypes.object,
  productNameStyle: PropTypes.object,
  productDetailsStyle: PropTypes.object,
  brandLogoStyle: PropTypes.object,
  brandNameStyle: PropTypes.object,
  productDateStyle: PropTypes.object,
  portfolioImage: PropTypes.object,
  portfolioDetails: PropTypes.object
};

ProductList.defaultProps = {
  topRow: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px'
  },
  topCol: {
    pr: '15px',
    pl: '15px',
    width: ['100%', '100%', '50%', '50%']
  },
  secTitleWrapper: {
    width: ['100%', '100%', '60%', '50%', '50%'],
    mb: '45px'
  },
  secTitle: {
    fontSize: ['22px', '26px', '26px', '30px', '30px'],
    fontWeight: '600',
    color: 'headingColor',
    lineHeight: '1.34',
    mb: ['15px', '18px', '18px', '20px', '20px']
  },
  secDescription: {
    fontSize: ['15px', '16px'],
    fontWeight: '400',
    color: 'textColor',
    lineHeight: '1.5',
    mb: '0'
  },
  productLogoStyle: {
    ml: 'auto',
    mr: 'auto',
    mb: '25px'
  },
  productNameStyle: {
    fontSize: ['16px', '16px', '18px', '20px'],
    fontWeight: '600',
    color: 'headingColor',
    lineHeight: '1.35',
    textAlign: 'center',
    mb: '17px'
  },
  productDetailsStyle: {
    fontSize: ['15px', '15px', '15px', '16px'],
    color: 'textColor',
    lineHeight: '1.5',
    textAlign: 'center',
    mb: '0'
  },
  brandLogoStyle: {},
  brandNameStyle: {
    fontSize: '16px',
    color: 'labelColor',
    lineHeight: '1.35',
    fontWeight: '600',
    mb: '4px'
  },
  productDateStyle: {
    fontSize: '12px',
    color: '#labelColor',
    lineHeight: '1.35',
    mb: '0'
  },
  portfolioImage: {
    width: [1, 1, 1 / 4]
  },
  portfolioDetails: {
    width: [1, 1, 3 / 4]
    // p: ['30px 0 0 0', '40px 0 0 0', '0 0 0 30px', '0 50px', '0 50px']
  }
};

export default ProductList;
